// extracted by mini-css-extract-plugin
module.exports = {"content":"content--KkVYx","btn":"btn--6P+EK","finance_micro__div":"finance_micro__div--gmhIB","footerBox":"footerBox--2XVdC"};